import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatSelect } from '@angular/material/select';
import { Subscription } from 'rxjs';

import { ControlError } from '../../models';

@Component({
  selector: 'kt-special-input',
  templateUrl: './special-input.component.html',
  styleUrls: ['./special-input.component.scss'],
})
export class SpecialInputComponent implements OnInit, OnDestroy {
  private subscriptions = new Subscription();
  private _control: FormControl;
  required: boolean;
  @ViewChild('input') input: ElementRef;
  @ViewChild('select') select: MatSelect;
  @Input() id: string;
  @Input() label: string;
  @Input() placeholder: string;
  @Input() size: 'sm' | 'md' | 'lg' = 'md';
  @Input() color: 'primary' | 'secondary' | 'tertiary' | 'neutral' = 'neutral';
  @Input() options: string[] = [];
  @Input() errors: ControlError[] = [];
  @Input()
  set control(control: FormControl) {
    if (!control) return;

    this._control = control;
    this.required = false;

    if (control.validator) {
      const validator = control.validator({} as any);
      this.required = !!validator?.required;
    }
  }
  get control(): FormControl {
    return this._control;
  }

  ngOnInit(): void {
    this.subscriptions.add(
      this.control.valueChanges.subscribe((input) => {
        if (input && input[input.length - 1] === '{') {
          this.select.open();
        } else {
          this.select.close();
        }
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  handleSelection(value: string): void {
    this.control.setValue(`${this.control.value}${value}}`);
    this.select.value = '';

    setTimeout(() => {
      this.input.nativeElement.focus();
    });
  }
}
